export default __webpack_public_path__ + "static/media/330_dummy2016-allgemeinarzt01-mobile-de.941ed000.png";